module.exports = __webpack_public_path__ + "img/R6__0818.4577693e.jpeg";